module.exports = __webpack_public_path__ + "static/media/btn_android_es.5a729e0c.png";